export default __webpack_public_path__ + "static/media/bubble-orange.5a152cab.svg";